let env = '';
if (window.location.hostname.indexOf('m-dev') >= 0) {
  env = '-dev';
} else if (window.location.hostname.indexOf('m-test05') >= 0) {
  env = '-test';
} else if (window.location.hostname.indexOf('m.stage') >= 0 || window.location.hostname.indexOf('m-stage') >= 0) {
  env = '-stage';
}
const lifeMenu = [
  {
    url: `${window.location.origin}/tmall/home`,
    icon: 'shopping',
    name: '优选生活',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/chaoshi`,
    icon: 'chaoshi',
    name: '东福超市',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/tmall/activity/index`,
    icon: 'packages',
    name: '节日礼包',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/newmovie`,
    icon: 'movies',
    name: '电影',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    // url: `${window.location.origin}/tmall/birthday`,
    url: `${window.location.origin}/newBirthday`,
    icon: 'birthday',
    name: '生日汇',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/scenery/list`,
    icon: 'travel',
    name: '旅游玩乐',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/drama_h5/home`,
    icon: 'shows',
    name: '演出话剧',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/wap/health/index`,
    icon: 'health',
    name: '健康生活',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/common/activity/home`,
    icon: 'activity',
    name: '企业活动',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: 'https://m-fuman-employee.ztbx.com/sso?page=personalinsure&source=01&platform=1',
    icon: 'fumanperson',
    name: '保险',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  },
  {
    url: `${window.location.origin}/book`,
    icon: 'book',
    name: '图书',
    isShow: 0 //参照后台接口返回状态为零,保持一致
  }
];

export default lifeMenu;
